export default __webpack_public_path__ + "static/media/chevron-left.b193bd10.svg";